export default __webpack_public_path__ + "a4758253d2bdc803b2534cefaa57860d.svg";